import {ChangeDetectorRef, Component, effect, inject, signal, WritableSignal} from '@angular/core';
import {CalculusStore} from "../../../Services/calculus.store";
import {SafePipe} from "frontier/browserkit/src/lib/pipes/safe.pipe";

@Component({
  selector: 'app-help-view',
  standalone: true,
  imports: [SafePipe],
  templateUrl: './help-view.component.html',
  styleUrl: './help-view.component.scss',
})
export class HelpViewComponent {
  calculusStore: CalculusStore = inject(CalculusStore);
  cdr: ChangeDetectorRef = inject(ChangeDetectorRef);

  href: WritableSignal<string> = signal(null);

  constructor() {
    effect((): void => {
      let helpRoute: string = this.calculusStore.helpRoute() || '';
      if (helpRoute == 'null') {
        helpRoute = '';
      }
      const url: string = 'https://abrechenknecht.hilfe.digitalgedacht.de/' + helpRoute;
      this.href.set(null);
      this.cdr.detectChanges();
      setTimeout((): void => {
        this.href.set(url)
      }, 50)
    }, {allowSignalWrites: true});
  }
}
